import { render } from "./Drill.vue?vue&type=template&id=7b9b7a9f&scoped=true"
import script from "./Drill.vue?vue&type=script&lang=js"
export * from "./Drill.vue?vue&type=script&lang=js"

import "./Drill.vue?vue&type=style&index=0&id=7b9b7a9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b6b000019df918e5ba178116dc1dcf84/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9b7a9f"]])

export default __exports__